import {MY_TOURNAMENT_PRINT_KIT_RESPONSE_SUCCESS} from '../actions/tournamentPrintKitRequest.actions';

export default function tournamentPrintKitRequest(state = null, action) {
  switch (action.type) {
    case MY_TOURNAMENT_PRINT_KIT_RESPONSE_SUCCESS: {
      return action.tournamentPrintKitRequest;
    }
  }
  return state;
}
